function IconShieldX({ color = 'currentColor', size = 24 }: { color?: string; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 10L14 14M14 10L10 14M12 3C14.3358 5.06658 17.3844 6.14257 20.5 6C20.9535 7.54302 21.0923 9.16147 20.9081 10.7592C20.7238 12.3569 20.2203 13.9013 19.4274 15.3005C18.6344 16.6998 17.5683 17.9254 16.2924 18.9045C15.0165 19.8836 13.5567 20.5962 12 21C10.4432 20.5962 8.98344 19.8836 7.7075 18.9045C6.43157 17.9254 5.36547 16.6998 4.57255 15.3005C3.77964 13.9013 3.27609 12.3569 3.09183 10.7592C2.90757 9.16147 3.04636 7.54302 3.49996 6C6.61548 6.14257 9.66413 5.06658 12 3Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

IconShieldX.displayName = 'IconShieldX';

export default IconShieldX;
